import { render, staticRenderFns } from "./ModalDownload.vue?vue&type=template&id=f394fee2&scoped=true"
import script from "./ModalDownload.vue?vue&type=script&lang=js"
export * from "./ModalDownload.vue?vue&type=script&lang=js"
import style0 from "./ModalDownload.vue?vue&type=style&index=0&id=f394fee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f394fee2",
  null
  
)

export default component.exports